import Loadable from 'react-loadable';
import Loading from '../../Components/Loading';

export default Loadable({
  loader: () => import('./DashboardPage'),
  loading: Loading,
});



// WEBPACK FOOTER //
// ./src/app/views/Pages/DashboardPage/index.js